namespace BsTest {

    /**
     * Testovaci trida pro BS
     */
    export class BsTestClass {
        a: number;
        b: string;

        /**
         * Testovaci constructor
         * @param a
         * @param b
         */
        constructor(a: number, b: string) {
            this.a = a;
            this.b = b;
        }
        public getA() {
            return this.a;     
        }

        public getB() {
            return this.b; 
        }
    }
} 

//debugger;
//var c = new BsTest.BsTestClass(1, "kukuaaaasdfasdfsd"); 